import React from "react";
import "./SearchResultHeader.scss";
import TotalRecordsCounter from "../TotalRecordsCounter/TotalRecordsCounter";
import ToggleManuals from "../../../common/ToggleManuals/ToggleManuals";
import ClientSideExcelExporter from "../../../common/ClientSideExcelExporter/ClientSideExcelExporter";
import { LABELKEYS_SEARCH_RESULTS } from "../../../../helper/constants";
import { useTranslation } from "react-i18next";

interface SearchResultHeaderProps {
  apiPayload?: any;
  recordsCounter: number;
  searchData?: any;
  // these props for mode switching
  isManualMode?: boolean;
  isLoadingManualData?: boolean;
  onSwitchToManualMode?: () => void;
  onSwitchToNormalMode?: () => void;
  showModeButtons?: boolean;
  noPubIdsAvailable?: boolean;
}

const SearchResultHeader: React.FC<SearchResultHeaderProps> = ({
  apiPayload,
  recordsCounter,
  searchData,
  isManualMode = false,
  isLoadingManualData = false,
  onSwitchToManualMode,
  onSwitchToNormalMode,
  showModeButtons = false,
  noPubIdsAvailable = false
}) => {
  const { t } = useTranslation();

  if (recordsCounter <= 0 && !isManualMode || !apiPayload) {
    return null;
  }

  const handleToggle = () => {
    if (isLoadingManualData) return;

    if (isManualMode) {
      onSwitchToNormalMode?.();
    } else {
      onSwitchToManualMode?.();
    }
  };
  // Get appropriate toggle label based on state
  const getToggleLabel = () => {
    if (isManualMode) {
      return 'Show All Results';
    }
    return 'Show My Manuals';
  };

  return (
    <div className="parent">
      <div className="left">
        {!(isManualMode && noPubIdsAvailable) && recordsCounter > 0 && (
          <TotalRecordsCounter totalRecords={recordsCounter} />
        )}
        {/* Show message when in manual mode with no pubIds */}
        {isManualMode && noPubIdsAvailable && !isLoadingManualData && (
          <div className="erro-msg">
            No subscribed manuals are available.
          </div>
        )}

      </div>
      <div className="right">
        {showModeButtons && (
          <div className="toggle-manuals-container">
            <div className="toggle-container">
              <span className={`toggle-label ${isManualMode ? 'active' : ''} ${isLoadingManualData ? 'loading' : ''}`}>
                {getToggleLabel()}
              </span>
              <div
                className={`toggle-switch ${isManualMode ? 'toggled' : ''} ${isLoadingManualData ? 'disabled' : ''}`}
                onClick={handleToggle}
                style={{
                  cursor: isLoadingManualData ? 'not-allowed' : 'pointer'
                }}
              >
                <div className="toggle-slider">
                  <div className={`toggle-knob ${isManualMode ? 'toggled' : ''}`} />
                </div>
              </div>
            </div>
          </div>
        )}

        {!(isManualMode && noPubIdsAvailable) && recordsCounter > 0 && (
          <ClientSideExcelExporter
            buttonTitle={t(LABELKEYS_SEARCH_RESULTS.EXPORT_SEARCH_RESULT)}
            searchData={searchData}
            apiPayload={apiPayload}
            recordsCounter={recordsCounter}
          />
        )}
      </div>
    </div>
  );
};

export default SearchResultHeader;